module.exports = __webpack_public_path__ + "img/item3.f3c2f91b.png";